let _provider = null

export function setFeatureFlagProvider (provider) {
  _provider = provider
}

export function getFeatureFlag (flagKey, defaultValue = false) {
  if (_provider) {
    try {
      return !!_provider.getFlag(flagKey, defaultValue)
    } catch (_) {}
  }
  return !!defaultValue
}
